import {Component, ElementRef, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {searchBarAnimation} from './search-bar.animation';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  animations: [
    searchBarAnimation
  ]
})
export class SearchBarComponent {
  @ViewChild('input', { read: ElementRef<HTMLInputElement> }) private inputElement: ElementRef<HTMLInputElement>;

  public readonly searchCtrl: FormControl<string> = new FormControl<string>(null);

  public opened: boolean = false;

  public focusIn(): void {}

  public focusOut(event: FocusEvent): void {
    if (event.relatedTarget === null) {
      if (!this.searchCtrl.value) {
        this.opened = false;
        this.searchCtrl.reset();
      }
    } else {
      this.inputElement.nativeElement.focus();
    }
  }

  public click(): void {
    this.opened = true;
  }

  public clear(): void {
    this.opened = false;
    this.searchCtrl.reset();
  }

}
